var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86082 7.839L0.293814 0.5H5.64433L9 5.27639L12.3866 0.5H17.7371L12.1082 7.839L18 15.5H12.634L9 10.3614L5.35052 15.5H0L5.86082 7.839Z",
    fill: "url(#paint0_linear_1_259)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_259",
    x1: 9,
    y1: 0.5,
    x2: 9,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FF76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464015,
    stopColor: "#72F138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BBD1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.1df0e370d0fbcc27bdbe1e3a51540222.svg";
export { ForwardRef as ReactComponent };